const inline = (text) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? (
      <strong key={`${i}-${part}`} className="font-semibold text-slate-900">{part.slice(2, -2)}</strong>
    ) : (
      part
    )
  );

export function renderBlock(block, key) {
  const lines = block.split("\n").map((l) => l.trim()).filter(Boolean);
  if (lines.length === 1 && lines[0].startsWith("## ")) {
    return (
      <h2 key={key} className="font-display pt-4 text-2xl font-semibold tracking-tight text-slate-900">
        {inline(lines[0].slice(3))}
      </h2>
    );
  }
  if (lines.length === 1 && lines[0].startsWith("### ")) {
    return (
      <h3 key={key} className="font-display pt-2 text-xl font-semibold tracking-tight text-[#6D28D9]">
        {inline(lines[0].slice(4))}
      </h3>
    );
  }
  if (lines.every((l) => l.startsWith("- "))) {
    return (
      <ul key={key} className="space-y-2 pl-1">
        {lines.map((l, i) => (
          <li key={`${i}-${l}`} className="flex gap-3 text-base leading-relaxed text-slate-700">
            <span className="mt-[11px] h-1.5 w-1.5 shrink-0 bg-[#6D28D9]" />
            <span>{inline(l.slice(2))}</span>
          </li>
        ))}
      </ul>
    );
  }
  return (
    <p key={key} className="text-base leading-relaxed text-slate-700">
      {inline(lines.join(" "))}
    </p>
  );
}
